/**
 * @file: ReworkRequestBody.tsx
 *
 * `OrgReworkRequest` — a defect was filed against a finished job;
 * shows the responsible member chip + optional remarks.
 */

import { Typography } from '@euler/app/components/typography';
import { Avatar } from '@euler/components/Avatar';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { OrgReworkRequestFeedPayload } from '@euler/model/feed';
import { FC } from 'react';
import { View } from 'react-native';
import { deliveryCheckSceneName } from './common/labels';
import { BodyText, TitleText, valueColor } from './common/primitives';

export const ReworkRequestBody: FC<{ p: OrgReworkRequestFeedPayload }> = ({
  p,
}) => {
  const { rpx } = useResponsiveContext();
  return (
    <View>
      <TitleText color="#b91c1c">{p.title || '返单请求'}</TitleText>
      <BodyText mt={2} color="#9ca3af">
        {deliveryCheckSceneName(p.sceneType)}
      </BodyText>
      <View
        css={`
          flex-direction: row;
          align-items: center;
          margin-top: ${rpx(8)}px;
        `}
      >
        <Avatar
          uri={p.responsibleMemberAvatar}
          name={p.responsibleMemberName}
          css={`
            width: ${rpx(24)}px;
            height: ${rpx(24)}px;
            border-radius: ${rpx(12)}px;
          `}
        />
        <Typography.Text ml={rpx(8)} size={rpx(12)} color="#6b7280">
          指派给
        </Typography.Text>
        <Typography.Text ml={rpx(4)} size={rpx(13)} color={valueColor} medium>
          {p.responsibleMemberName}
        </Typography.Text>
      </View>
      {p.remarks ? <BodyText mt={8}>{p.remarks}</BodyText> : null}
    </View>
  );
};
